import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTitle } from '../store/slices/titleSlice';
import { AppState } from '../store/store';
import get from 'lodash/get';

export const useTitle = () => {
  const dispatch = useDispatch();
  const { findAll } = useSelector((state: AppState) => state.title);

  useEffect(() => {
    dispatch(fetchTitle({ limit: 1000 }));
  }, []);

  return {
    items: get(findAll, 'payload.items', [])
  };
};
